import useIsMobile from '@/hooks/useIsMobile';
import OrderSnapshotModalDesktop from './desktop';
import OrderSnapshotModalMobile from './mobile';
import useOrderSnapshotModal from './useOrderSnapshotModal';

const OrderSnapshotModal = (props) => {
  const isMobile = useIsMobile(992);
  const viewModel = useOrderSnapshotModal(props);

  return isMobile
    ? <OrderSnapshotModalMobile {...props} viewModel={viewModel} />
    : <OrderSnapshotModalDesktop {...props} viewModel={viewModel} />;
};

export default OrderSnapshotModal;